<template>
    <b-button
      type="button"
      size="sm"
      variant="primary"
      v-on:click="updateUser"
    >
      <i class="fa fa-plus" ></i> Save
    </b-button>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";
    import {User} from "../../../models/User";
    import router from "../../../router";

    const UserRepo = RepositoryFactory.get('user');

    export default {
        name: 'user-update-button',
        props: {
            user: {
                type: Object,
                default: new User(),
            },
        },
        methods: {
            updateUser() {
                this.$emit('click')
                UserRepo
                    .updateUser(this.user.id, this.user)
                    .then(
                        response =>
                            (
                                this.$emit('change', response.data.data)
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            returnErrors(response) {
                this.$emit('click')
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
            },
        },
    }
</script>
